import React from "react";
import { X, AlertTriangle } from "lucide-react";
import type { EmailMonitoring } from "../../services/EmailHygieneService";

interface DeleteMonitoringModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  monitoring: EmailMonitoring | null;
}

const DeleteMonitoringModal: React.FC<DeleteMonitoringModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  monitoring,
}) => {
  if (!isOpen || !monitoring) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-background-paper dark:bg-background-paperDark rounded-xl max-w-md w-full mx-4">
        <div className="flex items-center justify-between p-6 border-b border-divider dark:border-divider-dark">
          <h2 className="text-xl font-semibold">Delete Monitoring</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-background-panel dark:hover:bg-background-panelDark rounded-lg text-text-secondary hover:text-text-primary transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className="p-3 bg-red-dark/10 rounded-full">
              <AlertTriangle className="w-6 h-6 text-red-dark" />
            </div>
            <div>
              <h3 className="font-medium mb-2">
                Delete monitoring for {monitoring.parameterEmail}?
              </h3>
              <p className="text-text-secondary text-sm">
                This will permanently delete the monitoring configuration and
                all associated data. This action cannot be undone.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-3 px-6 py-4 border-t border-divider dark:border-divider-dark">
          <button
            onClick={onClose}
            className="px-4 py-2 text-text-secondary hover:text-text-primary transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-dark hover:bg-red-dark/90 text-white rounded-lg transition-colors"
          >
            Delete Monitoring
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteMonitoringModal;
